export default function MoveInCashUnavailableNotice() {
  return (
    <div className="move-in-cash-unavailable-notice" role="status">
      <div className="micun-icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9" stroke="#F5A524" strokeWidth="1.5" />
          <path d="M10 6V11" stroke="#F5A524" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="10" cy="14" r="1" fill="#F5A524" />
        </svg>
      </div>
      <div className="micun-copy">
        <p className="micun-title">Move-In Cash isn't available yet</p>
        <p className="micun-body">
          Cash back is available within 30 days of your lease start date. You can still request a legacy check through
          Customer Care, or open a Stake Checking account.
        </p>
      </div>
    </div>
  );
}
